import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./components/App";
import "./index.scss";
import store from "./redux/configureStore";
import { Provider } from "react-redux";
import { Auth0ProviderWithNavigate } from "./auth0-provider-with-navigate";

const rootElement = document.getElementById("app");
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true
      }}
    >
      <Auth0ProviderWithNavigate>
        <App />
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </Provider>
);
